/**
 * Constants for the App Analytics (Mixpanel) panel
 */

export const EXAMPLE_QUESTIONS = [
  'Top 10 days for sessions',
  'Sessions by country',
  'Any anomalies?',
  'Give me insights',
  'Top users this month',
  'Sessions by city',
  'What are the trends?',
  'iOS vs Android',
  'Top 5 days for signups',
  'Where are users from?',
];

export const SUGGESTIONS_ROTATE_INTERVAL_MS = 8000; // Rotate every 8 seconds

export const CACHE_DATA_TYPE = 'analytics_summary';
export const CACHE_EXPIRY_MINUTES = 240; // 4 hours
export const LAST_QUERY_RESULT_DATA_TYPE = 'last_query_result';
export const SHARED_RESULT_POLL_INTERVAL_MS = 4000;
